var map = {
	"./modules/control-panel/control-panel.module": [
		"./src/app/modules/control-panel/control-panel.module.ts",
		"common",
		"modules-control-panel-control-panel-module"
	],
	"./modules/dashboard/dashboard.module": [
		"./src/app/modules/dashboard/dashboard.module.ts",
		"default~modules-dashboard-dashboard-module~modules-reporting-reporting-module",
		"common",
		"modules-dashboard-dashboard-module"
	],
	"./modules/help/help.module": [
		"./src/app/modules/help/help.module.ts",
		"common",
		"modules-help-help-module"
	],
	"./modules/reporting/reporting.module": [
		"./src/app/modules/reporting/reporting.module.ts",
		"default~modules-dashboard-dashboard-module~modules-reporting-reporting-module",
		"common",
		"modules-reporting-reporting-module"
	],
	"./modules/setup/setup.module": [
		"./src/app/modules/setup/setup.module.ts",
		"common",
		"modules-setup-setup-module"
	],
	"./modules/time/time.module": [
		"./src/app/modules/time/time.module.ts",
		"common",
		"modules-time-time-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;